import React from 'react';
import classnames from 'classnames';
import Cookies from 'universal-cookie';
import ScreenReaderButtonText from 'components/ScreenReaderText';
import { connect } from 'react-redux';
import { showCart, hideCart, restore } from './actions';
import CartIcon from 'images/icons/shopping-bag.svg?react-svg';
import { PrimaryButton, SecondaryButton } from 'scy/buttons';
import { inlineBlock } from 'scy/display.mod.scss';
import { valignMiddle } from 'scy/utils.mod.scss';
import padding from 'scy/padding.mod.scss';
import styles from './button.mod.scss';

let CartButton = class CartButton extends React.Component {
  constructor(props) {
    super(props);
    this.toggleCart = this.toggleCart.bind(this);
  }

  /* TODO: move cart restoration to server */
  componentDidMount() {
    const cookies = new Cookies();
    const anonToken = cookies.get('anon-user-token');
    const userToken = cookies.get('user-token');
    if (anonToken || userToken) this.props.restore();
  }

  toggleCart(e) {
    e.stopPropagation();
    this.props.show ? this.props.hideCart() : this.props.showCart();
  }

  render() {
    const active = !!this.props.products.length;
    const sumQuantity = this.props.products.reduce((sum, i) => sum + i.qty, 0);

    const Button = active ? PrimaryButton : SecondaryButton;

    return (
      <Button
        noBorder
        className={this.props.className}
        onClick={this.toggleCart}
      >
        <div
          className={classnames(
            valignMiddle,
            inlineBlock,
            padding.left_xs,
            padding.right_xs
          )}
        >
          <CartIcon width={18} height={24} />
          <ScreenReaderButtonText>Cart</ScreenReaderButtonText>
        </div>
        {!!sumQuantity && <div className={styles.text}>{sumQuantity}</div>}
      </Button>
    );
  }
};

CartButton = connect(
  state => ({
    show: state.cart.show,
    products: state.cart.products
  }),
  { showCart, hideCart, restore }
)(CartButton);

export default CartButton;
